// Dependencies
import React, { FunctionComponent, ReactNode, useRef, useState } from "react";

// Components
import { WebpChip } from "components/WebpChip";

// Assets
import handClapping from "./assets/handClapping.svg";
import vector from "./assets/vector.svg";

// Styles
import { Container, ContentWrapper, ContentNewWrapper } from "./styles";

// Types
type WebpNotificationPubMuralProps = {
    activeClapping: boolean;
    labelReadAllNotifications: string;
    labelNotNotification: string;
    contentComposition: ReactNode;
    contentNewComposition: ReactNode;
    onClickClear: () => void;
    onClickCloseDropDown: () => void;
};

export const WebpNotificationPubMural: FunctionComponent<WebpNotificationPubMuralProps> = ({
    activeClapping = false,
    onClickClear,
    onClickCloseDropDown,
    labelReadAllNotifications,
    labelNotNotification,
    contentComposition,
    contentNewComposition
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const contentNewWrapperRef = useRef<HTMLDivElement>(null);

    const [contentSlot, setContentSlot] = useState(false);

    const [isActiveChipFirst, setActiveChipFirst] = useState(true);

    const [isActiveChipLast, setActiveChipLast] = useState(false);

    const handleClickCloseDropDown = () => {
        onClickCloseDropDown();
    };

    const handleClearNotification = () => {
        onClickClear();
    };

    return (
        <Container ref={containerRef} buttonClearOff={activeClapping}>
            <div className="header">
                <div className="title-button">
                    <div className="buttonModal-title">
                        <button className="title" onClick={handleClickCloseDropDown}>
                            <img className="ocult-modal" src={vector} alt="vector" />
                            Notificações
                        </button>
                    </div>

                    {!!labelReadAllNotifications && (
                        <button className="button-clear" disabled={activeClapping} onClick={handleClearNotification}>
                            {labelReadAllNotifications}
                        </button>
                    )}
                </div>

                <div className="chip-wrapper">
                    <div className="webp-chip">
                        <WebpChip
                            label="Todas"
                            variant="neutral"
                            selected={isActiveChipFirst}
                            onChipSelected={() => {
                                setContentSlot(false);
                                setActiveChipFirst(true);
                                setActiveChipLast(false);
                            }}
                        />

                        <WebpChip
                            label="Não lidas"
                            variant="neutral"
                            selected={isActiveChipLast}
                            onChipSelected={() => {
                                setContentSlot(true);
                                setActiveChipLast(true);
                                setActiveChipFirst(false);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="content-slot">
                {!!activeClapping && isActiveChipLast && (
                    <div className="hand-label">
                        <img className="clapping" src={handClapping} alt="Mãos aplaudindo" />

                        <p className="label-not-notification">{labelNotNotification}</p>
                    </div>
                )}

                {!activeClapping && (
                    <ContentNewWrapper ref={contentNewWrapperRef} isTotalNotifications={contentSlot}>
                        {contentNewComposition}
                    </ContentNewWrapper>
                )}

                <ContentWrapper isNewNotifications={contentSlot}>{contentComposition}</ContentWrapper>
            </div>
        </Container>
    );
};
